import { MaterialModule } from './material.module';

export {
    MaterialModule
};